import { Component, Input, OnDestroy, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Departure } from '../../../_models/departure';
import { Inventory } from '../../../_models/inventory_loc';
import { Zone } from '../../../_models/zone';
import { OptiData } from '../../../_models/opti_data';
import { OptiPiece } from '../../../_models/opti_piece';
import { DbTransform } from '../../../_helpers/db.transform';
import { FormValidator } from '../../../_helpers/form.validator';
import { OptiValidator } from '../../opti.validator';
import { Subscription } from 'rxjs';
import { debounceTime, takeWhile } from 'rxjs/operators';


@Component({
  selector: 'app-opti-edit',
  templateUrl: './opti-edit.component.html'
})
export class OptiEditComponent implements OnInit, OnDestroy {

  title: string;
  subtitle: string;

  optiForm: FormGroup;
  locationForm: FormGroup;

  // tslint:disable-next-line:variable-name
  locationList_aux: Inventory[];
  inventoriesAux: Inventory[];
  locationsAux: Inventory[];
  
  // Listado de piezas resultantes del recupero.
  pieceList: any[];

  zonesPlatzAux: {
      name: string,
      zone: string
    }[];

  subscriptionList: Subscription[];
  componentActive: boolean;

  // Id del usuario actual logueado.
  // tslint:disable-next-line:variable-name
  current_user_id: number;
  // tslint:disable-next-line:variable-name
  current_group_id: number;
  // tslint:disable-next-line:variable-name
  current_username: string;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;
  locationModal: boolean;

  actionInfo: string;
  alertInfo: string;
  infoInfo: string;

  buttonRegisterDisabled: boolean;
  buttonSetLocationDisabled: boolean;
  today: Date;

  dbt: DbTransform;

  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;

  // tslint:disable-next-line:variable-name
  setTimeout_aux: number;

  @Input() inventory: Inventory;
  @Input() inventories: Inventory[];
  @Input() optiList: OptiData[];
  @Input() retalList: OptiPiece[];
  @Input() currentOpti: OptiData;
  @Input() lagerList: Departure[];
  @Input() locationList: Inventory[];
  @Input() zoneList: Zone[]; // Listado "ubicaciones - zona" filtrado ya para el usuario.
  @Input() zoneNameList: string[]; // Listado nombres de zonas del usuario.
  @Input() currentZone: Zone;
  @Input() existingSizes: any[]; //  Medidas que se podrán seleccionar en el selecetor de medidas disponibles
  @Input() lastRemnant: number;
  @Output() setLagers = new EventEmitter<any>();
  @Output() createOpti = new EventEmitter<any>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();
  @Output() setCurrentZone = new EventEmitter<Zone>();
  @Output() getUserNameZones = new EventEmitter<any>();
  @Output() getSizes = new EventEmitter<any>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder
  ) {
    this.formValidator = new FormValidator();
  }

  ngOnInit() {

    this.title = 'Optimizaciones';
    this.subtitle = 'Edición Optimización';
    this.subscriptionList = [];
    this.componentActive = true;

    this.dbt = new DbTransform(localStorage.getItem('enviroment'));

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(OptiValidator.templateMessages);

    this.setTimeout_aux = 3000;

    // {{ value_expression | date [ : format [ : timezone [ : locale ] ] ] }}
    this.today = new Date();

    this.infoInfo = 'El movimiento se ha realizado correctamente.';

    console.log('->->< inventory: ');
    console.log(this.inventory);

    // IMPORTANTE: Se inicializa el inventario de ubicaciones.
    this.inventoriesAux = [];
    this.locationList_aux = [];
    
    this.pieceList = [];

    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_group_id = Number(localStorage.getItem('group_id'));
    this.current_username = localStorage.getItem('username');

    if (this.current_username !== null && this.current_username !== undefined) {
      this.current_username = this.current_username.split('@')[0];
    }

    console.log('->->< Usuario actual logueado: ' + this.current_user_id + ' ;group_id = ' + this.current_group_id);
    console.log(this.current_username);

    this.optiForm = this.formBuilder.group({
      lag_mandant: null, // this.inventory[this.dbt.t('lag_mandant')], // Almacén vidrio del inventario
      lagm_platz: null, // this.inventory[this.dbt.t('lagm_platz')], // Ubicación vidrio del inventario
      lag_art_typ: null, // this.inventory[this.dbt.t('lag_art_typ')], // tipo de articulo, es en este caso será siempre 0
      lag_art_num: null, // this.inventory[this.dbt.t('lag_art_num')], // id material
      mat_desc: null, // this.inventory[this.dbt.t('mat_desc')], // material
      lag_bestand: null, // this.inventory[this.dbt.t('lag_bestand')], // unidades total en el almacén
      lag_referenz: null, // this.inventory[this.dbt.t('lag_referenz')], // referencia
      remnant_referenz: null,
      lag_breite: null, // this.inventory[this.dbt.t('lag_breite')], // anchura
      lag_hoehe: null, // this.inventory[this.dbt.t('lag_hoehe')], // altura
      remnant_breite:  [0, Validators.required],  // anchura del retal
      remnant_hoehe: [0, Validators.required],  // altura del retal
      num_remnant_piece: 1,  // numero de retales de un mismo tamaño de pieza que se añadirán al total de retales del recupero.
      num_remnant: [{value: 0, disabled: true}, Validators.required],  // número de retales a registrar.
      num_remnant_registered: [{value: 0, disabled: true}, Validators.required], // número de retales ya registrados.
      lagm_menge: null, // this.inventory[this.dbt.t('id_lager_st')],  // Unidades disponibles
      final_units: 1, // [1, OptiValidator.rangeUnitsValidator(1, this.inventory[this.dbt.t('lagm_menge')])], // vidrios consumidos
      origin_units_before: 0,
      origin_units_after: 0,
      origin_lag_bestand: null, // this.inventory[this.dbt.t('lag_bestand')],
      destination_lag_bestand: 0,
      m2Retal: 0,
      m2Consumidos: 0,
      user_id: this.current_user_id,
      group_id: this.current_group_id,
      username: this.current_username,
      waste_percentage: 0 + ' %', // porcentaje de desperdicio
      waste: 0 + ' m²', // desperdicio
      anti_waste_percentage: 0 + ' %', // porcentaje de aprovechamiento de retales
      anti_waste: 0 + 'm²', // aprovechado
      remnant_lager: ['', Validators.required],  // almacen retal
      remnant_zone: ['', Validators.required],  // zona retal
      remnant_location: [{value: '', disabled: true}, Validators.required], // ubicacion retal
      check: false,
      sizeSelector: null,
      barcode: null,
      piece_list: this.pieceList,
      retal_list: this.retalList
    });


    this.locationForm = this.formBuilder.group( {
      lager: null,
      location: null,
      zone: null
    });
    
    this.buttonRegisterDisabled = true;

    // Se cargan en el estado global los nombres de las zonas asociadas al grupo del usuario actual.
    // Se pasaría el id del usuario si quisiéramos ser aún más restrictivos, pero no es el caso.
    this.getUserNameZones.emit({
      user_id: this.current_user_id,
      group_id: this.current_group_id,
      lager: null }); // this.optiForm.controls.lag_mandant.value });

    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.optiForm);
    
    // Se ajustan los números de hoja de los retales
	this.adjustNumberSheet(this.retalList);

    // Inicializar el desperdicio
    // this.calculateWaste();
    this.calculateAntiWaste();

    // Se subscribe el formulario para controlar cuando cambia alguno de sus campos.
    // Esto se hace para poder activar o no el botón de confirmación del modal.
    // const auxControl = this.optiForm;

    // Para sólo tener en cuenta un campo específico.
    const ControlBreite = this.optiForm.get('remnant_breite');
    const ControlHoehe = this.optiForm.get('remnant_hoehe');
    const ControlfinalUnits = this.optiForm.get('final_units');
    const ControlNumRemnant = this.optiForm.get('num_remnant');
    const ControlCheck = this.optiForm.get('check');
    const ControlSizeSelector = this.optiForm.get('sizeSelector');

    this.subscriptionList.push(ControlBreite.valueChanges.pipe(
      takeWhile(() => this.componentActive)) // Tiempo de espera antes de lanzar la acción.
      .subscribe(value => {
         console.log('--> Cambio de valor ANCHURA en formulario optiForm = ');
         console.log(value);
         // this.calculateWaste();
         this.calculateAntiWaste();
      }));

    this.subscriptionList.push(ControlHoehe.valueChanges.pipe(
      takeWhile(() => this.componentActive)) // Tiempo de espera antes de lanzar la acción.
      .subscribe(value => {
         console.log('--> Cambio de valor ALTURA en formulario optiForm = ');
         console.log(value);
         // this.calculateWaste();
      }));

    this.subscriptionList.push(ControlfinalUnits.valueChanges.pipe(
      takeWhile(() => this.componentActive)) // Tiempo de espera antes de lanzar la acción.
      .subscribe(value => {
         console.log('--> Cambio de valor UNIDADES CONSUMIDAS en formulario optiForm = ');
         console.log(value);
         // this.calculateWaste();
      }));

    this.subscriptionList.push(ControlNumRemnant.valueChanges.pipe(
      takeWhile(() => this.componentActive)) // Tiempo de espera antes de lanzar la acción.
      .subscribe(value => {
         console.log('--> Cambio de valor NÚMERO RETALES en formulario optiForm = ');
         console.log(value);
         // this.calculateWaste();
         //this.calculateAntiWaste();
      }));

    this.subscriptionList.push(ControlSizeSelector.valueChanges.pipe(
      takeWhile(() => this.componentActive)) // Tiempo de espera antes de lanzar la acción.
      .subscribe(value => {
        console.log('--> Cambio de valor MEDIDAS DISPONIBLES en formulario optiForm = ');
        console.log(value);

        this.optiForm.controls.remnant_breite.setValue( Number(this.optiForm.controls.sizeSelector.value[this.dbt.t('lag_breite')]));
        this.optiForm.controls.remnant_hoehe.setValue(Number(this.optiForm.controls.sizeSelector.value[this.dbt.t('lag_hoehe')]));

        // this.calculateWaste();
        this.calculateAntiWaste();
      }));

    this.subscriptionList.push(ControlCheck.valueChanges.pipe(takeWhile(() => this.componentActive)) // Tiempo de espera antes de lanzar la acción.
      .subscribe(value => {
        console.log('--> Cambio de valor CHECK en formulario optiForm = ');
        console.log(value);

        if (this.optiForm.controls.check.value === true) {
          this.optiForm.controls.remnant_breite.setValue(0);
          this.optiForm.controls.remnant_hoehe.setValue(0);

          this.getSizes.emit({
            lager: this.optiForm.controls.lag_mandant.value,
            material: this.optiForm.controls.lag_art_num.value,
            breite: this.optiForm.controls.lag_breite.value,
            hoehe: this.optiForm.controls.lag_hoehe.value
          });
        }

        // this.calculateWaste();
        this.calculateAntiWaste();
      }));

  } // End function OnInit

  // convenience getter for easy access to form fields
  get f() { return this.optiForm.controls; }
  
  
  // Función que ajusta el valor del identificador de la hoja
  // al que pertenece el retal. Esto se hace porque cuando
  // se han usado hojas infinitas el ID viene aumentado en 2.
  adjustNumberSheet(retalListIn): void {
	
	console.log('--> Ejecutanco adjustNumberSheet...');
    console.log(retalListIn);
        
	if (retalListIn[0].sheet_id - 2 > 0) {
		
		console.log('--> Ajustando ID de hojas.');
		
		retalListIn.forEach(ret => {
			ret.sheet_id -= 2;
		});		
	}
  } // End function adjustNumberSheet.

  calculateAntiWaste(): void {
	
	let num_retal_selected = 0;
	let num_retal_no_selected = 0;
	
	this.retalList.forEach(ret => {
		if (!ret.barcode) {
			num_retal_selected++;
		} else {
			num_retal_no_selected++;
		}
	});
	
	this.optiForm.controls.num_remnant.setValue(num_retal_selected);
	this.optiForm.controls.num_remnant_registered.setValue(num_retal_no_selected);
	
 } // End function calculateAntiWaste.

  calculateWaste(): void {
    
    if (this.inventory[this.dbt.t('id_lager_st')] < this.optiForm.controls.final_units.value) {
      this.optiForm.controls.final_units.setValue(this.inventory[this.dbt.t('id_lager_st')]);
    }
    
    // tslint:disable-next-line:max-line-length
    this.optiForm.controls.m2Consumidos.setValue((((this.inventory[this.dbt.t('lag_breite')] * this.inventory[this.dbt.t('lag_hoehe')]) / 1000000)
      * this.optiForm.controls.final_units.value));

    console.log('m2Consumidos: ' + this.optiForm.controls.m2Consumidos.value);

	let total_m2_retal = 0;
	
	// Se inicializa el contador de metros cuadrados recuperados.
	total_m2_retal = 0;
    
    // Se recorren todos los retales para volver a calcular el total de metros que se pretenden recuperar.
    this.pieceList.forEach(piece => {
      	total_m2_retal += ((piece.width * piece.height) / 1000000) * piece.unit;
    });

    // tslint:disable-next-line:max-line-length
    this.optiForm.controls.m2Retal.setValue(total_m2_retal);

    console.log('m2Retal: ' + this.optiForm.controls.m2Retal.value);

    // tslint:disable-next-line:max-line-length
    this.optiForm.controls.waste.setValue((this.optiForm.controls.m2Consumidos.value - this.optiForm.controls.m2Retal.value).toFixed(2) + 'm²');

    console.log('waste: ' + this.optiForm.controls.waste.value);

    const percentage = (100 - (this.optiForm.controls.m2Retal.value * 100 ) / this.optiForm.controls.m2Consumidos.value);

    this.optiForm.controls.waste_percentage.setValue(percentage.toFixed(2) + '%');
    console.log('waste_percentage: ' + this.optiForm.controls.waste_percentage.value);
  } // End function calculateWaste.

  buttonValidateOpti(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del
    // formulario son correctos. El número de retales a registrar no puede ser cero.
/*
    console.log('this.optiForm.controls.final_units.value: ');
    console.log(this.optiForm.controls.final_units.value);
    console.log(this.optiForm.controls.lagm_menge.value);

    console.log('this.optiForm.controls.sizeSelector.value: ');
    console.log(this.optiForm.controls.sizeSelector.value);
    console.log(this.optiForm.controls.sizeSelector);

    if ( this.optiForm.controls.check.value === true ) {
        this.optiForm.controls.remnant_breite.setValue( Number(this.optiForm.controls.sizeSelector.value[this.dbt.t('lag_breite')]));
        this.optiForm.controls.remnant_hoehe.setValue(Number(this.optiForm.controls.sizeSelector.value[this.dbt.t('lag_hoehe')]));
        this.optiForm.controls.remnant_referenz.setValue(this.optiForm.controls.sizeSelector.value[this.dbt.t('lag_referenz')]);
        this.optiForm.controls.destination_lag_bestand.setValue(this.optiForm.controls.sizeSelector.value[this.dbt.t('lag_bestand')]);
    }

    // tslint:disable-next-line:max-line-length
    this.optiForm.controls.m2Consumidos.setValue((((this.inventory[this.dbt.t('lag_breite')] * this.inventory[this.dbt.t('lag_hoehe')]) / 1000000)
      * this.optiForm.controls.final_units.value));

    // tslint:disable-next-line:max-line-length
    this.optiForm.controls.m2Retal.setValue(((( this.optiForm.controls.remnant_breite.value * this.optiForm.controls.remnant_hoehe.value) / 1000000)
      * this.optiForm.controls.num_remnant.value));

    console.log('Consumido m2: ' + this.optiForm.controls.m2Consumidos.value);

    console.log('Retal m2:' + this.optiForm.controls.m2Retal.value);

    console.log('Check:' + this.optiForm.controls.check.value);
*/
    // VALIDATE

    if (this.optiForm.valid && (this.f.m2Retal.value <= this.f.m2Consumidos.value)) {
	  if (Number(this.optiForm.controls.num_remnant.value) < 1) {		
		this.alertInfo += '- No hay retales para registrar en el listado de "Retales Recuperables".<br>';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});		
	  } else {
		console.log('-------> Formulario opti correcto.');
      	this.showActionModal(true);
	  }
      
    } else {
      console.log('-------> Formulario optiForm NO válido:');
      console.log(this.optiForm);

      this.alertInfo = 'El formulario no está correctamente rellenado:<br>';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      
      if (Number(this.optiForm.controls.num_remnant.value) < 1) {		
		this.alertInfo += '- No hay retales para registrar en el listado de "Retales Recuperables".<br>';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});		
	  }
	  
	   if (!this.optiForm.controls.remnant_location.value || this.optiForm.controls.remnant_location.value === 'Sin asignar' || this.optiForm.controls.remnant_location.value === '') {
        this.alertInfo += '- Debe seleccionar una ubicación.<br>';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      }
/*
      if (this.f.m2Retal.value > this.f.m2Consumidos.value) {
        // tslint:disable-next-line:max-line-length
        this.alertInfo += '-Las medidas (' + this.f.m2Retal.value + ' m²) superan la cantidad de vidrio disponible (' + this.f.m2Consumidos.value + ' m²).<br>';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      }

      if (this.optiForm.controls.final_units.value <= 0
         || this.optiForm.controls.final_units.value > this.optiForm.controls.lagm_menge.value) {

          this.alertInfo += '-La cantidad de unidades seleccionadas no puede ser menor que uno '
            + 'ni tampoco mayor que el número de unidades disponibles.<br>';
          this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      }

      if (this.optiForm.controls.num_remnant.value === '' || this.optiForm.controls.num_remnant.value <= 0) {
        this.alertInfo += '- Debe seleccionar un número correcto de retales a crear.<br>';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      }

     
      if ((this.optiForm.controls.remnant_breite.value === '') || (this.optiForm.controls.remnant_hoehe.value === '')
         || (this.optiForm.controls.remnant_breite.value <= 0) || (this.optiForm.controls.remnant_hoehe.value <= 0)) {
        this.alertInfo += ' - Debe introducir la medida correctamente.<br>';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      } // */
    }
    this.alertInfo = '';
  } // End function buttonValidateOpti

  saveOpti(): void {

    let barcode: number;
    let tam: number;

    if ( this.lastRemnant === null || this.lastRemnant === undefined ) {

      console.log('No hay retales aún');
      // Genera un código de barras aleatorio en el caso de que no haya existencia de alguna pieza de retal

      do {
        barcode = Math.round(Math.random() * (70000000 - 10000000000000) + 10000000000000);
        tam = barcode.toString().length;
        console.log('tam: ' + tam);

      } while ( tam % 2 );
    } else {
      console.log('Hay retales creados');

      do {
        barcode = this.lastRemnant + 1;
        tam = barcode.toString().length;
        console.log('tam: ' + tam);
      } while ( tam % 2 );
    }

    // ------------ Fin código de barras

    // tslint:disable-next-line:variable-name
    let origin_units_after = 0;
    // tslint:disable-next-line:variable-name
    const origin_units_before = this.optiForm.controls.lag_bestand.value;
    // tslint:disable-next-line:variable-name
    let origin_lag_bestand = 0;

    // Se busca si la referencia a mover coincide con alguna de las existentes dentro de la ubición destino.
    // Si es así la cantidad a mover se sumaría con las unidades que ya estuviesen ahí.
    // Si no existe ninguna referencia similar para esa ubicación entonces habrá que crearla
    // y el total de unidades sería sólamente el número de elementos que se han movido.
/*
    console.log('this.optiForm.controls.m2Retal.value:');
    console.log(this.optiForm.controls.m2Retal.value);
    console.log('this.optiForm.controls.m2Consumidos.value:');
    console.log(this.optiForm.controls.m2Consumidos.value);

    origin_units_after = this.optiForm.controls.lag_bestand.value - this.optiForm.controls.final_units.value;
    // Valor de almacén origen antes del movimiento
    origin_lag_bestand = this.inventory[this.dbt.t('lag_bestand')];
    console.log('origin_units_after: ');
    console.log(origin_units_after);

    // Se calcula el número total de unidades que tendrá la ubicación origen después de la recuperación.
    this.optiForm.controls.origin_units_before.setValue(origin_units_before);
    this.optiForm.controls.origin_units_after.setValue(origin_units_after);
    this.optiForm.controls.origin_lag_bestand.setValue(origin_lag_bestand);
    this.optiForm.controls.barcode.setValue(null); // barcode
    
    // Incluimos el listado piezas.
    this.optiForm.controls.piece_list.setValue(this.pieceList);
*/  

	// Incluimos en el listado retales sólo los que no estén registrados aún.
	
	let retalListNoRegistered = [];
	
	retalListNoRegistered = this.retalList.filter(ret => !ret.barcode);
	
    this.optiForm.controls.retal_list.setValue(retalListNoRegistered);
    // NOTA: Hay que asignar un código de barras diferente a cada unidad de cada pieza de retal.
    // Se hará en el controldor.

    // NOTA: Se copian los cambios sobre la variable que se va a devolver.
    // IMPORTANTE: Si algún campo tiene valor "undefined" entonces no se incluirá en el envío y no aparecerá en el controlador.
    const p = { ...this.currentOpti, ...this.optiForm.value };

    if (this.optiForm.valid) {
      console.log('-------> Formulario de Registro correcto');
      console.log(p);

      this.createOpti.emit(p);

    } else {
      console.error('No se han introducido valores válidos en los campos del formulario.');
    }

  } // End function saveOpti

  buttonSelectLocation() {
    console.log('-> -> Seleccionado buttonSelectLocation:');
    this.optiForm.controls.remnant_zone.setValue(this.locationForm.controls.zone.value[this.dbt.t('zone_name')]);
    this.optiForm.controls.remnant_location.setValue(this.locationForm.controls.location.value);
    this.optiForm.controls.remnant_lager.setValue(this.locationForm.controls.lager.value);
    this.showLocationModal(false);
  } // End function buttonSelectLocation


  buttonLocationOpti(inventory: Inventory) {
    console.log('-> -> Pulsado buttonLocationOpti:');
    console.log(inventory);

    // Se actualizan los almacenes y ubicaciones.
    // Hay que volver a hacerlo porque en esta nueva consulta el resultado
    // no debe estar agrupado para el desplegable del selector.
    this.setLagers.emit({
      filterLagerName: null, // 'RETAL',
      filterLagerMat: null,
      filterLagerWidth: null,
      filterLagerHeight: null,
      filterLagerGreater: true
    });

    this.inventoriesAux = [];
    this.zoneNameList = [];
    this.locationsAux = [];

    this.locationForm.controls.lager.setValue(this.optiForm.controls.lag_mandant.value);
    this.locationForm.controls.zone.setValue(null);
    this.locationForm.controls.location.setValue(null);

    // tslint:disable-next-line:max-line-length
    if (this.locationForm.controls.lager.value === undefined || this.locationForm.controls.lager.value === '' || this.locationForm.controls.lager.value === null) {
      this.locationForm.controls.lager.setValue('KALCIYAN');
      this.getUserNameZones.emit({
        lager: this.locationForm.controls.lager.value,
        user_id: this.current_user_id,
        group_id: this.current_group_id,
      });
    } else {
      this.getUserNameZones.emit({
        lager: this.locationForm.controls.lager.value,
        user_id: this.current_user_id,
        group_id: this.current_group_id,
      });
    }

    // Mostramos la ventana de selección de ubicación.
    this.showLocationModal(true);
    this.buttonSetLocationDisabled = true;

  } // End function buttonLocationOpti

  changeLager(): void {
    console.log('---> Cambiando Almacén:');
    console.log(this.locationForm.controls.lager.value);

    // Se inicializa el selector de ubicación.
    this.locationForm.controls.location.setValue(null);
    this.inventoriesAux = [];

    this.locationForm.controls.zone.setValue(null);
    this.locationForm.controls.location.setValue(null);
    this.locationsAux = [];

    // Se inicializan el stock de las ubicaciones.
    this.zoneNameList = [];

    this.getUserNameZones.emit({
      lager: this.locationForm.controls.lager.value,
      user_id: this.current_user_id,
      group_id: this.current_group_id,
    });

    this.buttonSetLocationDisabled = true;

  } // End function changeLager


  changeZone(): void {

    console.log('---> Cambiando Zona:');
    console.log(this.locationForm.controls.zone.value);

    this.setCurrentZone.emit(this.locationForm.controls.zone.value);

    console.log('->><> zoneNameList:');
    console.log(this.zoneNameList);

    console.log('->><> zoneList:');
    console.log(this.zoneList);

    // IMPORTANTE: Se inicializa el inventario de ubicaciones.
    this.inventoriesAux = [];

    // Se filtran las localizaciones para que sólo muestre las que existen en esa zona.
    const zonesAux = this.zoneList.filter(zone =>
      (this.locationForm.controls.zone.value[this.dbt.t('zone_name')] === zone[this.dbt.t('lagm_zone')]
        && this.locationForm.controls.lager.value === zone[this.dbt.t('lagm_mandant')]));

    console.log('zonesAux => ');
    console.log(JSON.stringify(zonesAux));
    console.log(zonesAux.length);

    // Se inicializan las ubicaciones por zona.
    this.zonesPlatzAux = [];

    let nameZonesPlatzAux = [];

    zonesAux.forEach(element => {
      this.zonesPlatzAux.push({ name: element[this.dbt.t('lagm_platz')], zone: element[this.dbt.t('lagm_zone')] });
      nameZonesPlatzAux.push(element[this.dbt.t('lagm_platz')]);
    });

    console.log('->><> zonesPlatzAux:');
    console.log(this.zonesPlatzAux);

    console.log('->><> nameZonesPlatzAux:');
    console.log(nameZonesPlatzAux);

    // NOTA: Ordenamos las ubicaciones por orden alfabético porque si hay muchas resulta complicado encotrar la deseada.
    nameZonesPlatzAux = this.orderLocations(nameZonesPlatzAux);

    this.locationsAux = nameZonesPlatzAux;

    // Se deselecciona el selector de ubicación.
    this.locationForm.controls.location.setValue(null);

    // Se habilita el selector de ubicación.
    this.buttonSetLocationDisabled = true;

  } // End function changeZone

  orderLocations(arrayIn: string[]) {

    console.log('---> Ordenando Ubicaciones...');
    return arrayIn.sort((a, b) => {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
  } // End function orderCompositionsByGenre

  changeLocation(): void {
    console.log('---> Cambiando Ubicación:');
    console.log(this.locationForm.controls.location.value);

    if (this.locationForm.controls.lager.value === null) {
      console.log('---> El almacén es nulo.');
      this.inventoriesAux = [];
    } else {
      this.inventoriesAux = this.locationsAux;
    }

    this.buttonSetLocationDisabled = this.inventoriesAux.length <= 0;
  }

  // NOTA: Fitro con función que obtiene de un array los
  // valores que no sean superiores a cero de un campo dado.
  filterZeroItems(listIn: [], fieldIn: string) {
    return listIn.filter(x => x[fieldIn] > 0);
  } // End function filterZeroItems

  // Función para añadir una línea de retal al recupero resultante.
  buttonAddRetal(): void {
    
    console.log('---> Entrando en buttonAddRetal:');
    console.log(this.optiForm.controls.num_remnant_piece.value);
    
    let new_piece = {
      type: this.f['check'].value ? 'Vidrio' : 'Retal', 
      id_mat: this.inventory[this.dbt.t('lag_art_num')],
      mat_desc: this.inventory[this.dbt.t('mat_desc')],
      width: this.f['check'].value ? this.optiForm.controls.sizeSelector.value[this.dbt.t('lag_breite')] : this.optiForm.controls.remnant_breite.value,
      height: this.f['check'].value ? this.optiForm.controls.sizeSelector.value[this.dbt.t('lag_hoehe')] : this.optiForm.controls.remnant_hoehe.value,
      unit: this.optiForm.controls.num_remnant_piece.value
    };
    
    if (new_piece.width <= 0 || new_piece.height <= 0) {
    	this.alertInfo = '· La pieza debe tener medidas superiores a cero.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    } else if (new_piece.unit <= 0) {
    	this.alertInfo = '· La pieza debe tener un número de unidades superior a cero.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    } else {
        // Se añade 1 al número de piezas.
    	this.optiForm.controls.num_remnant.setValue(this.optiForm.controls.num_remnant.value + this.optiForm.controls.num_remnant_piece.value);
    
    	this.pieceList.push(new_piece);
    }
    
    // Se actualizan los cálculos.
    // this.calculateWaste();
    this.calculateAntiWaste();
  } // End function buttonAddRetal
  
  removePiece(indexIn: number): void {
    console.log('---> Entrando en removePiece: ' + indexIn);
    
    let num_aux = 1; // this.retalList[indexIn].unit;
    
    // Se elimina la pieza del listdo.
	this.retalList.splice(indexIn, 1);
    
    // Se resta el número de unidades de esa entrada al número total de piezas.
    this.optiForm.controls.num_remnant.setValue(this.optiForm.controls.num_remnant.value - num_aux);
    
  } // End function removePiece
  
  // ---------------- Función filtro para selector en HTMl.
  // Función usada como parámetro para aplicar a cada elemento como filto de un Pipe propio.
  // NOTA: Para usarlo hay que importar la librería correspondiente desde el archivo xxxx.module.ts del componente.
  // En este caso asegura que sólo se muestre un almacén, RETAL, cuando se trabaje desde el entorno "kalciyan".
  filterRetal(element: any, aux: any): boolean {
    console.log('filterRetal Item -> aux1 = ' + aux);
    console.log(element);
	
	if (localStorage.getItem('enviroment') === 'kalciyan') {
    
    	if (aux.param2 === true) {
            if (element[aux.param1] === 'RETAL') {
		      console.log('-> Hay almacén RETAL.');
		      return false;
		    } else {
	          return true;
	      	}
        } else {
          	if (element[aux.param1] === 'RETAL') {
		      console.log('-> Hay almacén RETAL.');
		      return true;
		    } else {
	          return false;
	      	}
        }
    } /* else {
    	// NOTA: En el filtrado se pone directamente el nombre del campo en mayúsculas (sin usar el db.tr)
	    // porque la función se pasa el código al archivo del "Pipe" y no coge las variables "this". Por
	    // esta razón el nombre del campo se pasa aquí como parámetro para saber directamente su valor.
	    
	    if (element[aux] !== 'RETAL') {
	      console.log('-> No es almacén RETAL.');
	      return true;
	    }
	
	    console.log('-> Detectado almacén RETAL.')
	    return false;
    }  */
    
    return true; // Por defecto devolverá todos los almacenes incluído el de RETAL si existiera.
    
  } // End function filterRetal
  
  // --------------------------------

  showLocationModal(value: boolean) {
    this.locationModal = value;

  } // End function showLocationModal

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    this.saveOpti();

    this.showActionModal(false);
  } // End function confirmActionModal

  back(): void {
    this.router.navigate(['/opti_list']);
  } // End function back

  ngOnDestroy() {
    console.log('--> --> Destruyendo componente opti-edit...');

    // Se desactiva la subscripción al formulario de producto.
    this.componentActive = false;

    this.actionModal = false;
    this.locationModal = false;

    this.unsubscribeAll();

    // Desactivamos todas las subscripciones de los campos de formulario.
    this.formValidator.setValidatorActive(false);

  } // End function ngOnDestroy

  unsubscribeAll() {
    this.subscriptionList.forEach( item => {
      item.unsubscribe();
    });

    this.subscriptionList = [];
  } // End function unsubscribeAll
  
  // Función que obtiene el primer elemento de un array JSON pasado como cadena.
  getProductId(value) {
	return JSON.parse(value)[0];
  }

} // End Class OptiEditComponent
